import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase'; // 설정파일 불러오기
import { collection, getDocs } from 'firebase/firestore';
import '../styles/Sidebar.css';

const Sidebar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isReviewOpen, setIsReviewOpen] = useState(false);
  const [isReadOpen, setIsReadOpen] = useState(false);

  // 1. 하드코딩 대신 파이어베이스 데이터를 담을 상태 생성
  const [issues, setIssues] = useState([]);

  // 2. 컴포넌트 마운트 시 데이터 불러오기
  useEffect(() => {
    const fetchIssues = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'issues'));
        const fetchedIssues = querySnapshot.docs.map((doc) => ({
          id: doc.data().id,
          title: doc.data().title,
        }));

        // id 순서대로 정렬 (1호, 2호...)
        fetchedIssues.sort((a, b) => a.id - b.id);
        setIssues(fetchedIssues);
      } catch (error) {
        console.error('사이드바 목록 로드 실패:', error);
      }
    };

    fetchIssues();
  }, []);

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <>
      <button className={`sidebar-toggle-btn ${isOpen ? 'active' : ''}`} onClick={() => setIsOpen(!isOpen)}>
        {isOpen ? '✕' : '☰'}
      </button>

      <nav className={`sidebar ${isOpen ? 'open' : ''}`}>
        <ul className="menu-list">
          <li className="menu-item">
            <Link to="/" className="menu-title" onClick={handleLinkClick}>
              풋소설 소개
            </Link>
          </li>

          {/* 글 읽기 드롭다운 */}
          <li className={`menu-item ${isReadOpen ? 'active' : ''}`}>
            <button className="menu-title dropdown-toggle" onClick={() => setIsReadOpen(!isReadOpen)}>
              글 읽기
              <span className={`arrow ${isReadOpen ? 'up' : 'down'}`}>{isReadOpen ? '▴' : '▾'}</span>
            </button>
            <ul className="submenu">
              {issues.map((issue) => (
                <li key={`read-${issue.id}`} className="submenu-item">
                  <Link
                    to={`/content/${issue.id}`}
                    state={{ id: issue.id, title: issue.title, mode: 'story' }}
                    onClick={handleLinkClick}
                  >
                    제{issue.id}호 ⟪{issue.title}⟫
                  </Link>
                </li>
              ))}
            </ul>
          </li>

          {/* 후기 게시판 드롭다운 */}
          <li className={`menu-item ${isReviewOpen ? 'active' : ''}`}>
            <button className="menu-title dropdown-toggle" onClick={() => setIsReviewOpen(!isReviewOpen)}>
              후기 게시판
              <span className={`arrow ${isReviewOpen ? 'up' : 'down'}`}>{isReviewOpen ? '▴' : '▾'}</span>{' '}
            </button>
            <ul className="submenu">
              {issues.map((issue) => (
                <li key={`review-${issue.id}`} className="submenu-item">
                  <Link
                    to={`/content/${issue.id}`}
                    state={{ id: issue.id, title: issue.title, mode: 'review' }}
                    onClick={handleLinkClick}
                  >
                    제{issue.id}호 ⟪{issue.title}⟫
                  </Link>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </nav>

      {isOpen && <div className="sidebar-overlay" onClick={() => setIsOpen(false)}></div>}
    </>
  );
};

export default Sidebar;
